import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import ScreenContainer from "../../components/ScreenContainer";
import Header from "../../components/Header";
import { typography } from "../../styles/typography";
import colors from "../../styles/colors";
import EditDoc from "./images/EditDoc";
import TrendUp from "./images/TrendUp";
import AddChart from "./images/AddChart";
import Footer from "../../components/Footer";
import common from "../../styles/common";

const RecoveryLanding = () => {
  const navigate = useNavigate();
  const [currentSection, setCurrentSection] = useState(0)
  const [isBtnVisible, setBtnVisible] = useState(false)
  const titles = useRef(["혜택", "비교", "상세", "가격", "정책", "FAQ", "시작하기"])

  const handleScroll = () => {
    if (!isBtnVisible) setBtnVisible(true)
  }
  const handleConfirm = () => {
    navigate("/plan")
  };

  return (
    <ScreenContainer style={style.container}>
      <Header
        withBackButton={false}
        renderRight={() =>
          <Button
            text={"Membership"}
            style={style.membershipBtn}
          />}
      />
      <div style={style.tab}>
        {titles.current.map((value, i) => <a href="#" key={i} style={currentSection == i ? style.tabLabelOn : style.tabLabel}>{value}</a>)}
      </div>
      <div className={"scrollContainer"} style={style.scrollContainer} onScroll={handleScroll}>

        {/*section 1*/}
        <div className="large_title_32">혜택</div>
        <h1 className={"title_l_28_medium mt-16"} >Eyes deserve longevity, too.</h1>
        <p className={"description body_15_regular mt-16"}>
          Eyeary는 단순한 기기가 아니라, 당신의 첫 번째 눈 일기입니다. 매일의 작은 기록이 쌓여, 시야를 지키는 가장 확실한 방법이 됩니다.
        </p>

        <div style={style.section} className="mt-40">
          <div className="mt-40" />
          <Content
            icon={<EditDoc color={colors.primaryColor100} />}
            title={"Daily Eye Diary"}
            subtitle={"눈 건강을 기록하는 새로운 습관"}
            description={"매일 쌓이는 작은 기록이 당신만의 눈 다이어리가 됩니다."}
            titleColor={colors.primaryColor200}
          />
          <Content
            icon={<TrendUp color={colors.primaryColor100} />}
            title={"Daily Mode(무료)"}
            subtitle={"무료로 시작할 수 있는 예방 루틴"}
            description={"AI가 추천하는 루틴과 함께 더 선명한 시야에 도전하세요."}
            titleColor={"#3BC4FF"}
            className={"mt-48"}
          />
          <Content
            icon={<AddChart color={colors.primaryColor100} />}
            title={"Performance Mode(유료)"}
            subtitle={"정밀 측정과 맞춤 훈련으로 개선을 이어가는 루틴"}
            description={"AI가 추천하는 루틴과 함께 더 선명한 시야에 도전하세요."}
            className={"mt-48"}
            titleColor={"#56FFD2"}
          />
          <Content
            icon={<AddChart color={colors.primaryColor200} />}
            title={"Personal Insight"}
            subtitle={"7일·30일 변화 그래프, 눈 점수, 피로도까지."}
            description={"데이터가 당신의 Eye Diary에 기록되어 시야 변화를 확인할 수 있습니다."}
            className={"mt-48"}
            titleColor={colors.primaryColor100}
          />
        </div>

        {/* section 2 */}
        <div className="large_title_32" style={{ marginTop: 116 }}>비교</div>
        <h1 className={"title_l_28_medium mt-16"} >
          <span style={{ color: "#3BC4FF" }}>Protection 예방 루틴</span><br />
          vs<br />
          <span style={{ color: "#56FFD2" }}>Recovery 개선 루틴</span></h1>
        <p className={"description body_15_regular mt-16"}>
          어떤 루틴으로 아이 다이어리를 기록할까요?
        </p>

        <div style={style.section2cards}>
          <div style={style.protectionCardBg}>
            <div style={style.cardTitleBg}>Daily Mode(무료)</div>
            <div style={style.cardContentContainer}>
              <div style={style.cardContentBg}>예방 중심 루틴</div>
              <div style={style.cardContentBg}>고정 5분 시간 선택</div>
              <div style={style.cardContentBg}>선명히 보이는 근/원거리 측정</div>
              <div style={style.cardContentBg}>기본 훈련만 가능</div>
              <div style={style.cardContentBg}>AI 추천 제공 안 함</div>
              <div style={style.cardContentBg}>기본 눈 건강 관리</div>
              <div style={style.cardContentBg}>무료</div>
            </div>
          </div>

          <div style={{ ...style.protectionCardBg, ...style.recoveryCardBg }}>
            <div style={style.recoverySub}>
              <div style={{ ...style.cardTitleBg, color: colors.recoveryColor500 }}>Performance Mode (유료)</div>
              <div style={style.cardContentContainer}>
                <div style={style.cardContentBg}>개선 중심 루틴</div>
                <div style={style.cardContentBg}>5/10/15/20분 시간 선택 가능</div>
                <div style={style.cardContentBg}>정밀 측정 + 변화 리포트</div>
                <div style={style.cardContentBg}>AI 추천 루틴 제공</div>
                <div style={style.cardContentBg}>개인 맞춤 루틴 + 상세 분석</div>
                <div style={style.cardContentBg}>30일 무료 → 월 $4.99 / 연 $49</div>
                <div style={{ flex: 1 }} />
                <Button
                  text={"구독하기"}
                  style={style.subscribe}
                />
              </div>
            </div>
          </div>
        </div>

        {/* section 3 */}
        <div className="large_title_32" style={{ marginTop: 116 }}>상세 비교</div>
        <h1 className={"body_15_regular mt-16"} >아래 표는 기능·측정·리포트·정책까지 포함한 상세 사양입니다.</h1>
        <p className={"description caption_12_light mt-16"}>
          <div style={{ marginBottom: 8 }}>MAX값: 사용자에게 가장 선명하게 보이는 거리(최대 선명 거리)</div>
          훈련 중 흐림: Protection모드는 평지를 걷는 것 같다면, Recovery모드는 계단오르기와 같이 난이도가 있는 훈련을 진행하기에, 진행 시 일시적으로 흐린 현상이 느껴질 수 있습니다.
        </p>
        <div style={style.section3cards}>
          <div style={style.protectionCardSm}>
            <div style={style.cardTitleSm}>Daily Mode(무료)</div>
            <div style={style.cardContentContainerSm}>
              이런 분께 Protection(무료)<br/>
              <span style={{ color: colors.mono300 }}>
                짧고 가벼운 예방 루틴을 원함
                흐림 없이 일상 중 편안하게 사용하고 싶음
                기본 측정만으로도 충분
              </span>
            </div>
          </div>

          <div style={{ ...style.protectionCardSm, ...style.recoveryCardSm }}>
            <div style={style.recoverySubSm}>
              <div style={{ ...style.cardTitleSm, color: colors.recoveryColor500 }}>Performance Mode (유료)</div>
              <div style={style.cardContentContainerSm}>
                이런 분께 Recovery(유료)<br />
                <span style={{ color: colors.mono300 }}>
                  선명도 개선과 눈 근력 강화를 목표로 함
                  정밀 측정 + 변화 리포트 + AI 추천이 필요
                  세션 시간/강도 선택이 중요
                </span>
              </div>
            </div>
          </div>
        </div>

        <Footer style={{ marginTop: 150 }} />
      </div>
      {isBtnVisible && <div className="button-wrapper">
        <Button
          text="무료 체험 시작하기"
          onClick={handleConfirm}
          className={"primary-on-button primary-button-text"}
        />
      </div>}

    </ScreenContainer>
  );
};

const Content = ({ icon, title, subtitle, description, className, titleColor }) => {
  return <div style={style.content} className={className}>
    {icon}
    {title ? <div style={{ ...style.contentTitle, color: titleColor }} className="mt-16">{title}</div> : <div style={{ marginTop: 10 }} />}
    <div style={style.subtitle}>{subtitle}</div>
    <div style={style.contentDescription}>{description}</div>
  </div>
}

const style = {
  container: {
    maxHeight: '100vh',
    overflow: 'hidden'
  },
  tab: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0px 15px',
    marginTop: 10,
    marginBottom: 10
  },
  tabLabel: {
    ...typography.body["14_regular"],
    color: colors.mono500
  },
  tabLabelOn: {
    color: colors.primaryColor100
  },
  scrollContainer: {
    flex: 1,
    overflowY: 'scroll',
    overflowX: 'hidden',
    textAlign: 'center',
    color: colors.primaryColor100,
    paddingTop: 62,
  },
  section2cards: {
    display: 'flex',
    minHeight: 392,
    gap: 16,
    overflowX: 'scroll',
    width: '100vw',
    padding: '0px 16px',
    marginTop: 34
  },
  protectionCardBg: {
    width: "298px",
    flexShrink: 0,
    borderRadius: 20,
    backgroundColor: colors.surfaceColor800,
    display: 'flex',
    flexDirection: 'column',
    padding: '40px 15px 14px',
    gap: 24,
    overflow: 'hidden',
    border: `1px solid ${colors.surfaceBorderColor}`,
  },
  recoveryCardBg: {
    background: `linear-gradient(#0A5A56 0 0) padding-box,
    linear-gradient(132deg, #00E6D3, #0A5A56 55%) border-box`,
    backgroundColor: colors.surfaceColor800,
    border: '1px solid transparent',
    padding: '0px'
  },
  recoverySub: {
    padding: '40px 15px 14px',
    backgroundColor: colors.surfaceColor800,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardTitleBg: {
    ...typography.title.m_22_medium,
    color: colors.protectionColor500
  },
  cardContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    color: colors.white,
    width: '100%',
    ...typography.body["15_regular"],
  },
  subscribe: {
    ...common.primaryOnButton,
    height: 38,
    backgroundColor: colors.primaryColor500
  },

  section3cards: {
    display: 'flex',
    minHeight: 160,
    gap: 16,
    overflowX: 'scroll',
    width: '100vw',
    padding: '0px 16px',
    marginTop: 40
  },
  protectionCardSm: {
    width: 320,
    flexShrink: 0,
    borderRadius: 20,
    backgroundColor: colors.surfaceColor800,
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 20px',
    overflow: 'hidden',
    border: `1px solid ${colors.surfaceBorderColor}`,
  },
  recoveryCardSm: {
    background: `linear-gradient(#0A5A56 0 0) padding-box,
    linear-gradient(132deg, #00E6D3, #0A5A56 55%) border-box`,
    backgroundColor: colors.surfaceColor800,
    border: '1px solid transparent',
    padding: '0px'
  },
  recoverySubSm: {
    padding: '16px 20px',
    backgroundColor: colors.surfaceColor800,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardTitleSm: {
    ...typography.title.s_18_medium,
    color: colors.protectionColor500,
    marginBottom: 10
  },
  cardContentContainerSm: {
    flexDirection: 'column',
    gap: 10,
    color: colors.white,
    width: '100%',
    ...typography.body["15_regular"],
    flex: 1
  },
  section: {
    borderRadius: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    paddingBottom: 56,
    backgroundColor: colors.surfaceColor600

  },
  subtitle: {
    ...typography.title.m_24_medium,
    color: '#56FFDA',
  },
  subsubtitle: {
    ...typography.title.s_18_medium,
    color: '#FFF',
  },
  subtag: {
    ...typography.caption_12_regular,
    color: '#fff',
    backgroundColor: colors.primaryColor800,
    borderRadius: 5,
    padding: '2px 6px',
    marginTop: 10
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px 18px'

  },
  contentTitle: {
    ...typography.body["18_medium"],
    color: '#fff',
    textAlign: 'center'
  },
  contentDescription: {
    ...typography.body["15_regular"],
    color: colors.mono300,
    marginTop: 6,
    textAlign: 'center'
  },
  subtitle: {
    ...typography.body["15_medium"],
    color: colors.white,
    marginTop: 6,
    textAlign: 'center'
  },
  membershipBtn: {
    padding: '4px 7px',
    borderRadius: 100,
    border: `1px solid ${colors.mono700}`,
    color: colors.mono300,
    marginRight: 25,
    ...typography.caption_12_regular
  },
}

export default RecoveryLanding;
